"use client";
import React, { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

export interface IAutoScrollSliderProps {
  children: React.ReactNode[];
  className?: string;
  swiperParent?: string;
  numberOfCards?: number;
  gradientClassName?: string;
  showGradient?: boolean;
  animationDuration?: number;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  isPaused?: boolean; // New prop for pause control
}

// import { IAutoScrollSliderProps } from "./interface";

const InfiniteLoopSlider = ({
  children,
  animationDuration,
  onMouseEnter,
  onMouseLeave,
  isPaused,
}: {
  children: any;
  animationDuration?: number;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  isPaused?: boolean;
}) => {
  return (
    <div
      className="relative box-border w-full overflow-hidden"
      key="loop"
      onMouseEnter={() => {
        if (onMouseEnter) onMouseEnter();
      }}
      onMouseLeave={() => {
        if (onMouseLeave) onMouseLeave();
      }}
    >
      <div
        className={cn(
          "autoscroll-marquee flex w-max flex-nowrap items-center gap-4 *:shrink-0",
        )}
        style={{
          animationDuration: animationDuration
            ? `${animationDuration}s`
            : `${Math.max(children.length * 1.5, 10)}s`,
          animationPlayState: isPaused ? "paused" : "running",
        }}
      >
        {children}
        {children}
      </div>
    </div>
  );
};

const AutoScrollSlider = ({
  children,
  numberOfCards = 10,
  swiperParent,
  gradientClassName = "",
  animationDuration,
  showGradient = false,
  isPaused = false,
}: IAutoScrollSliderProps) => {
  const [updatedChildren, setUpdatedChildren] = useState<
    React.ReactNode[] | null
  >(null);

  useEffect(() => {
    // create a copy of children (array)
    const original = Array.isArray(children) ? children.slice() : [children];
    const newChildren: React.ReactNode[] = [...original];

    // ensure at least numberOfCards * 2 (so loop has room)
    while (newChildren.length < numberOfCards * 2) {
      newChildren.push(...original);
    }

    setUpdatedChildren(newChildren);
  }, [children, numberOfCards]);

  return updatedChildren ? (
    <div className="relative w-full overflow-hidden">
      {showGradient && (
        <div
          className={`left-gradient absolute z-1 top-0 left-0 ${gradientClassName}`}
        />
      )}
      <div className={`relative overflow-hidden w-full ${swiperParent}`}>
        <InfiniteLoopSlider
          animationDuration={animationDuration}
          isPaused={isPaused}
        >
          {updatedChildren?.map((child, index) => (
            <div key={`autoscroll_${index}`} className="shrink-0">
              {child}
            </div>
          ))}
        </InfiniteLoopSlider>
      </div>
      {showGradient && (
        <div
          className={`right-gradient absolute z-1 top-0 right-0 ${gradientClassName}`}
        />
      )}
    </div>
  ) : (
    <></>
  );
};

export default AutoScrollSlider;
